import React, { useEffect, useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <Link to="/" className="nav-logo">
  
        <img 
          // src="/ajera_logo.svg" 
          src="/8 - Copy.png" 
          alt="AJERA Logo" 
          className="navbar__logo-img"
        />
        </Link>

      <ul className={`nav-links ${menuOpen ? 'nav-links--open' : ''}`}>
        {[
          { to: '/what-we-do', label: 'What We Do' },
          { to: '/who-we-are', label: 'Who We Are' },
          { to: '/update', label: 'Updates' },
          { to: '/careers', label: 'Careers' },
        ].map(item => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              className={({ isActive }) => isActive ? 'active' : ''}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div className="nav-right">
        <button className="nav-cta" onClick={() => { navigate('/contact'); setMenuOpen(false); }}>
          Contact Us
        </button>
        <button
          className={`nav-hamburger ${menuOpen ? 'nav-hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
